module.exports = __webpack_public_path__ + "media/images/proof_links/proof_green/youtube-75857f2104fa51b0a48fe940609cf7a5.svg";